module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', [_vm._m(0), _vm._v(" "), _c('section', [_c('select', {
    domProps: {
      "value": _vm.toneConfig.synth
    },
    on: {
      "change": _vm.changeSynth
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": "",
      "selected": "",
      "hidden": ""
    }
  }, [_vm._v("Select Synth")]), _vm._v(" "), _vm._l((_vm.possibleSynths), function(synth) {
    return _c('option', [_vm._v(_vm._s(synth))])
  })], 2), _vm._v(" "), (_vm.toneConfig.synth === 'Synth') ? _c('synth') : _vm._e(), _vm._v(" "), (_vm.toneConfig.synth === 'MonoSynth') ? _c('monosynth') : _vm._e(), _vm._v(" "), (_vm.toneConfig.synth === 'AMSynth') ? _c('amsynth') : _vm._e(), _vm._v(" "), (_vm.toneConfig.synth === 'FMSynth') ? _c('fmsynth') : _vm._e(), _vm._v(" "), (_vm.toneConfig.synth === 'DuoSynth') ? _c('duosynth') : _vm._e()], 1), _vm._v(" "), _c('hr'), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._l((_vm.effectsConfig), function(effect) {
    return _c('div', {
      staticClass: "effectConfig"
    }, [_c('label', [_vm._v(_vm._s(effect.name))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (effect.active),
        expression: "effect.active"
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "value": effect.name,
        "checked": Array.isArray(effect.active) ? _vm._i(effect.active, effect.name) > -1 : (effect.active)
      },
      on: {
        "change": function($event) {
          var $$a = effect.active,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = effect.name,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (effect.active = $$a.concat([$$v]))
            } else {
              $$i > -1 && (effect.active = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.$set(effect, "active", $$c)
          }
        }
      }
    }), _vm._v(" "), (effect.name === 'Chorus' && effect.active) ? _c('chorus') : _vm._e(), _vm._v(" "), (effect.name === 'Tremolo' && effect.active) ? _c('tremolo') : _vm._e(), _vm._v(" "), (effect.name === 'Vibrato' && effect.active) ? _c('vibrato') : _vm._e(), _vm._v(" "), (effect.name === 'Freeverb' && effect.active) ? _c('freeverb') : _vm._e()], 1)
  }), _vm._v(" "), _c('hr'), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('tonefilter')], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', {
    staticClass: "sectionHeader"
  }, [_c('span', [_vm._v("synth")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', {
    staticClass: "sectionHeader"
  }, [_c('span', [_vm._v("effects")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', {
    staticClass: "sectionHeader"
  }, [_c('span', [_vm._v("filter")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b3655b0e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/components/make_config/synth_config.vue
// module id = 291
// module chunks = 1